import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ADPResourceService as ResourceService, NotificationService, RequestCriticalLevel, SnackBarData, Snackbar } from 'digital-core';
import {  Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { SalesActivity } from '../models';
import { ConfigService } from './config.service';
import { HeaderFactoryService } from './header-factory.service';
import { TerashopResponse } from 'common/models/terashop/terashop-response.model';
import { SnackBarBodyComponent } from 'common';

@Injectable()
export class TerashopService {

    private httpClient: HttpClient;
    public terashopResponseSubject = new Subject<TerashopResponse>();
    public terashopRequestSubject = new Subject();
    public terashopResponseState = this.terashopResponseSubject.asObservable();
    public terashopRequestState = this.terashopRequestSubject.asObservable();

    constructor(handler: HttpBackend,
        private configService: ConfigService,
        private headerService: HeaderFactoryService,
        private notificationService: NotificationService,
        private resourceService: ResourceService
        ) {
        this.httpClient = new HttpClient(handler);
    }

    public loadTeraShopInBackground(salesActivity: SalesActivity): Promise<TerashopResponse> {
        const formData = new FormData();
        formData.append('salesActivity', JSON.stringify(salesActivity));
        this.terashopRequestSubject.next(null);
        return this.httpClient.post<TerashopResponse>(
            `${this.configService.apiUrl}api/v${this.configService.apiVersion
            }/terashop/create-order`,
            formData,
            this.headerService.getAuthorizationHeaderOptions(null,
                RequestCriticalLevel.Critical,
                formData
            )
        ).pipe(tap((res: TerashopResponse) => {
            this.terashopResponseSubject.next(res);
            if(!res.Success){
                let stringError='';
                if((res.ErrorList!=null ||  res.ErrorList!=undefined) && res.ErrorList.length>0)
                res.ErrorList.forEach(error=> {
                    stringError+=error.ErrorDescription;
                    }
                );   
                this.notificationService.showNotification(SnackBarBodyComponent,
                    new SnackBarData(
                        stringError,
                        this.resourceService.getViewLabel(
                            "Global_Payment_ErrorHeading"
                          ),
                      'error'
                    ),
                    new Snackbar("error")
                  );

            }
        })).toPromise();
    }
}
